import { q, qo } from '../../../shared/dom';
import { ctx2d } from './canvas';

interface Mote { x: number; y: number; r: number; vy: number; vx: number; a: number; ph: number; }

let motes: Mote[] = [];
let raf: number | null = null;

/** Pó de ouro flutuando: dá profundidade ao palco sem roubar atenção. */
export function startMotes(): void {
  const c = qo<HTMLCanvasElement>('#motes'); if (!c) return;
  const x = ctx2d(c);
  c.width = c.offsetWidth * devicePixelRatio; c.height = c.offsetHeight * devicePixelRatio;
  motes = Array.from({ length: 46 }, () => ({
    x: Math.random() * c.width, y: Math.random() * c.height,
    r: (.8 + Math.random() * 2.2) * devicePixelRatio,
    vy: -(.12 + Math.random() * .4) * devicePixelRatio,
    vx: (Math.random() - .5) * .25 * devicePixelRatio,
    a: .1 + Math.random() * .38, ph: Math.random() * 6
  }));
  if (raf) cancelAnimationFrame(raf);
  (function loop(ts: number) {
    x.clearRect(0, 0, c.width, c.height);
    motes.forEach(p => {
      p.y += p.vy; p.x += p.vx;
      if (p.y < -12) { p.y = c.height + 12; p.x = Math.random() * c.width; }
      x.fillStyle = `rgba(255,206,120,${p.a * (.6 + .4 * Math.sin(ts / 900 + p.ph))})`;
      x.beginPath(); x.arc(p.x, p.y, p.r, 0, 7); x.fill();
    });
    raf = q('#stage').hidden ? null : requestAnimationFrame(loop);
  })(0);
}
